import { AbstractPriceStore } from '@store/models/Price/AbstractPriceStore';

export class PriceStore extends AbstractPriceStore {
    public static Name = 'priceStore' as const;
}

export const priceStore = new PriceStore();
